/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';
import { UserBylineComponent } from './user-byline/user-byline.component';

@NgModule({
  declarations: [
    UserAvatarComponent,
    UserBylineComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    UserAvatarComponent,
    UserBylineComponent,
  ],
})
export class AvatarModule { }
